/* Regex rules for strings with numbers/names baked in. Order matters: first match wins. */
export const PATTERNS = [
  [/^(\d+) horses?$/, (m, n) => `${n} caballo${n === "1" ? "" : "s"}`],
  [/^(\d+) tasks?$/, (m, n) => `${n} tarea${n === "1" ? "" : "s"}`],
  [/^(\d+) shows?$/, (m, n) => `${n} show${n === "1" ? "" : "s"}`],
  [/^(\d+) classes$/, "$1 clases"], [/^1 class$/, "1 clase"],
  [/^(\d+) days?$/, (m, n) => `${n} día${n === "1" ? "" : "s"}`],
  [/^(\d+) items?$/, (m, n) => `${n} artículo${n === "1" ? "" : "s"}`],
  [/^(\d+) left$/, "faltan $1"], [/^(\d+) done$/, "$1 listas"], [/^(\d+) of (\d+)$/, "$1 de $2"],
  [/^(\d+) of (\d+) done$/, "$1 de $2 listas"], [/^(\d+)\/(\d+) done$/, "$1/$2 listas"],
  [/^Day (\d+)$/, "Día $1"], [/^Day (\d+) of (\d+)$/, "Día $1 de $2"], [/^Week (\d+)$/, "Semana $1"],
  [/^Checked off — added to (.+)'s show bill$/, "Marcado — se agregó a la cuenta del show de $1"],
  [/^Checked off — added to (.+)'s monthly bill$/, "Marcado — se agregó a la cuenta mensual de $1"],
  [/^Assigned to (.+)$/, "Asignado a $1"], [/^Assigned (.+)$/, "Asignado a $1"],
  [/^(.+) assigned to you$/, "$1 te fue asignado"],
  [/^Reminder sent to (.+)$/, "Recordatorio enviado a $1"],
  [/^Text sent to (.+)$/, "Texto enviado a $1"],
  [/^(\d+) min$/, "$1 min"], [/^(\d+) new$/, "$1 nuevos"], [/^(\d+) unread$/, "$1 sin leer"],
  [/^Starts in (\d+) days?$/, "Empieza en $1 días"], [/^Ends in (\d+) days?$/, "Termina en $1 días"],
  [/^(\d+) days? ago$/, "hace $1 días"], [/^(\d+) hours? ago$/, "hace $1 h"], [/^(\d+) minutes? ago$/, "hace $1 min"],
  [/^(\d+)h ago$/, "hace $1 h"], [/^(\d+)m ago$/, "hace $1 min"], [/^(\d+)d ago$/, "hace $1 d"],
  [/^Due (.+)$/, "Vence $1"], [/^Expires (.+)$/, "Vence $1"],
  [/^Next: (.+)$/, "Siguiente: $1"], [/^Up next: (.+)$/, "Siguiente: $1"],
  [/^Show: (.+)$/, "Show: $1"], [/^Owner: (.+)$/, "Dueño: $1"], [/^Horse: (.+)$/, "Caballo: $1"],
  [/^Welcome back, (.+)$/, "Bienvenido de nuevo, $1"], [/^Hi, (.+)$/, "Hola, $1"], [/^Good morning, (.+)$/, "Buenos días, $1"],
  [/^Good afternoon, (.+)$/, "Buenas tardes, $1"], [/^Good evening, (.+)$/, "Buenas noches, $1"],
  [/^Remove (.+)\?$/, "¿Quitar $1?"], [/^Delete (.+)\?$/, "¿Eliminar $1?"],
  [/^(.+) removed$/, "$1 eliminado"], [/^(.+) added$/, "$1 agregado"], [/^(.+) saved$/, "$1 guardado"], [/^(.+) updated$/, "$1 actualizado"],
  [/^New (.+)$/, "Nuevo $1"], [/^Edit (.+)$/, "Editar $1"], [/^Add (.+)$/, "Agregar $1"],
  [/^(.+) — tomorrow$/, "$1 — mañana"], [/^(.+) — today$/, "$1 — hoy"],
  [/^Only mine \((\d+)\)$/, "Solo mías ($1)"],
  [/^Lunge (.+)$/, "Dar cuerda a $1"], [/^Ride (.+)$/, "Montar a $1"],
  [/^Expired (\d+)d ago$/, "Venció hace $1 d"], [/^Expired (.+)$/, "Venció $1"], [/^(\d+)d left$/, "faltan $1 d"],
  [/^Next up (.+) · tap to prep$/, "Próximo $1 · toca para preparar"],
  [/^(\d+) things? left before (.+)$/, (m, n, show) => `${n} pendiente${n === "1" ? "" : "s"} antes de ${show}`],
  [/^(\d+) things? left before the show$/, (m, n) => `${n} pendiente${n === "1" ? "" : "s"} antes del show`],
  [/^(\d+) vet records? expiring within 60 days$/, (m, n) => `${n} registro${n === "1" ? "" : "s"} veterinario${n === "1" ? "" : "s"} por vencer en 60 días`],
  [/^(\d+) on you$/, "$1 para ti"], [/^(\d+)\/(\d+)$/, "$1/$2"],
  [/^Whiteboard (\d+)\/(\d+) done$/, "Pizarra $1/$2 listas"],
  [/^(.+) · (\d+)\/(\d+) done$/, "$1 · $2/$3 listas"],
];
